<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="section">
        <strong>Perfil de {{ $store.state.user.name }}</strong>
      </div>
    </div>

    <div class="ui divider"></div>

    <div class="ui grid">

      <div class="sixteen wide column">
        <div class="ui segment">
          <div class="ui form">
            <div class="fields">
              <div class="four wide field">
                <label class="form-label">Grupo</label>
                <input type="text" readonly="readonly" :value="user.groupName">
              </div>
              <div class="six wide field">
                <label class="form-label">Nome <span class="red text">*</span></label>
                <input type="text" v-model="user.name">
              </div>        
              <div class="six wide field">
                <label class="form-label">Sobrenome <span class="red text">*</span></label>
                <input type="text" v-model="user.lastName">
              </div>          
            </div>
            <div class="fields">
              <div class="four wide field">
                <label class="form-label">Login <span class="red text">*</span></label>
                <input type="email" v-model="user.login">
              </div>  
              <div class="six wide field">
                <label class="form-label">E-mail <span class="red text">*</span></label>
                <input type="email" v-model="user.email">
              </div>          
            </div>
          </div>
        </div>
      </div>

      <div class="sixteen wide column">
        <button type="button" class="ui button" @click="$refs.passwordUpdateDialog.show()">
          <i class="lock red icon"></i> Alterar senha
        </button>
        <button type="button" class="ui blue button m-l-10" :class="{ loading: updating }" @click="onUpdate()">
          <i class="check icon"></i> Atualizar dados
        </button>
      </div>

    </div>

    <password-update-dialog ref="passwordUpdateDialog" />

  </div>

</template>

<script>

  import { AppLocalStorage,  UserService } from "@/services"
  import Message from "@/utils/message"
  import PasswordUpdateDialog from "@/components/password-update-dialog.vue"

  export default { 

    data() {
      return {
        updating: false,
        user: {},
      }
    },

    components: {
      PasswordUpdateDialog,
    },

    created() {

      const { id, groupName, name, lastName, email, login } = this.$store.state.user

      this.user = {
        id,
        groupName,
        name,
        lastName,        
        email,
        login,
        password: "",
        pswConf: "",
      }
    },
    
    methods: {

      async onUpdate() {

        if (!this.validData())
          return

        this.updating = true
        
        try {

          await UserService.update(this.user)

          const user = await UserService.getById(this.user.id)

          AppLocalStorage.set("user", user, "setUser")
          
          Message.success("Dados atualizados com sucesso")

          this.updating = false
          
        } catch (error) {
          
          this.updating = false
          this.$errorHandler(error)
        }

      },

      validData() {

        let isOk = true
        let message = ""

        if (!this.user.name) {
          message = "Informe o nome"
        } else if (!this.user.lastName) {
          message = "Informe o sobrenome"
        } else if (!this.user.email) {
          message = "Informe o e-mail"
        } else if (!this.user.login) {
          message = "Informe o login"
        }
        
        if (message) {
          isOk = false
          Message.info(message)
        }

        return isOk
      },
    },
  }

</script>


